export default function ArticleHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Serene%20minimalist%20workspace%20with%20sleek%20laptop%20displaying%20colorful%20spreadsheet%20charts%20and%20graphs%20on%20a%20warm%20oak%20desk%2C%20morning%20sunlight%20casting%20soft%20diagonal%20shadows%20through%20plantation%20shutters%2C%20cream%20and%20sand%20interior%20with%20potted%20succulent%20and%20ceramic%20coffee%20cup%2C%20editorial%20photography%20with%20gentle%20depth%20of%20field%2C%20calm%20productive%20atmosphere&width=1800&height=1000&seq=article-hero-v4-2026&orientation=landscape"
          alt="Complete LitBuy Spreadsheet Guide 2026"
          title="LitBuy Spreadsheet Complete Guide"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <p className="text-xs md:text-sm text-white/70 uppercase tracking-widest mb-3">
          In-Depth Guide &bull; Updated June 2026
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-3 tracking-tight">
          LitBuy Spreadsheet Resource
        </h1>
        <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto leading-relaxed">
          Comprehensive guides, comparisons, and tutorials to help you master smart shopping with LitBuy spreadsheets.
        </p>
      </div>
    </section>
  );
}